import { Link } from "react-router-dom";
import { MaskedLine, FadeUp } from "@/components/motion";

const Section = ({ id, title, children }) => (
  <section id={id} className="scroll-mt-24 border-t border-[#DFE5DC] py-16" data-testid={`disclosure-${id}`}>
    <FadeUp>
      <h2 className="font-display text-3xl md:text-4xl tracking-tight text-[#0F1F1A] mb-8">{title}</h2>
    </FadeUp>
    <div className="grid gap-6 max-w-3xl">{children}</div>
  </section>
);

const P = ({ children }) => <p className="text-[#5C6B62] leading-relaxed text-sm md:text-base">{children}</p>;

export default function Disclosures() {
  return (
    <div data-testid="disclosures-page">
      <section className="px-6 pt-40 pb-16">
        <div className="max-w-7xl mx-auto">
          <p className="font-mono2 text-xs uppercase tracking-[0.3em] text-[#0C6B4F] mb-8">
            <MaskedLine delay={0.1}>Legal & Transparency</MaskedLine>
          </p>
          <h1 className="font-display font-light text-5xl md:text-6xl tracking-tight leading-[1.02] max-w-3xl text-[#0F1F1A]">
            <MaskedLine delay={0.25}>Disclosures &</MaskedLine>
            <MaskedLine delay={0.45}><span className="italic text-[#0C6B4F]">policies.</span></MaskedLine>
          </h1>
          <MaskedLine delay={0.7} className="mt-8 max-w-xl">
            <span className="text-[#5C6B62] leading-relaxed">
              We believe trust is built in the open. Everything about how Trusted Financial Hub operates, earns revenue and handles your information lives on this page.
            </span>
          </MaskedLine>
        </div>
      </section>

      <div className="px-6 pb-32">
        <div className="max-w-7xl mx-auto">
          <Section id="advertising" title="Advertising Disclosure">
            <P>
              Trusted Financial Hub is an independent, advertising-supported comparison service. When you click a link, submit a request, or engage with an offer listed on this website, we may receive compensation from the provider. This compensation is how we keep our comparison tools free for you.
            </P>
            <P>
              Compensation may influence which providers appear on this site and the order in which they are presented. It never influences the substance of our reviews, comparisons or recommendations, which follow documented editorial standards covering cost transparency, reporting practices and customer outcomes.
            </P>
            <P>
              Trusted Financial Hub does not include every provider or product available in the market. The appearance of a provider on this site does not constitute an endorsement of that provider by any regulatory body.
            </P>
          </Section>

          <Section id="privacy" title="Privacy Policy">
            <P>
              We collect only the information you choose to share through our forms — typically your name, contact details and the service you're interested in — along with technical data such as your IP address and browser type, used for security and analytics.
            </P>
            <P>
              Your information is used to respond to your request and to connect you with providers whose criteria match your profile. We never sell your personal information. Data is transmitted encrypted and retained only as long as needed to serve your request.
            </P>
            <P>
              You may request a copy or deletion of your information at any time by writing to info@trustedfinancialhub.com. We honor all requests within 30 days.
            </P>
            <P>
              <Link to="/privacy" className="underline text-[#0C6B4F]" data-testid="disclosures-privacy-link">Read the full Privacy Policy →</Link>
            </P>
          </Section>

          <Section id="terms" title="Terms of Service">
            <P>
              You must be 18 or older and a U.S. citizen or permanent resident to submit a request through this site. Trusted Financial Hub is not a lender, broker, or provider of the products compared here, and does not make credit decisions.
            </P>
            <P>
              Submitting a request does not guarantee approval, connection with a provider, or any specific terms. All rates, fees and repayment terms are determined solely by the provider you choose, and any agreement is strictly between you and that provider.
            </P>
            <P>
              Providers in our network may perform credit checks through one or more credit bureaus when reviewing your request; by submitting a request you consent to such checks. Services are not available in all states. We may restrict access from networks associated with abuse or fraudulent activity.
            </P>
          </Section>
        </div>
      </div>
    </div>
  );
}
